import {MenuItem, styled} from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
	cursor: default;

	&:hover {
		background-color: transparent;
	}
`;
